import { compose, mount, route } from 'navi';
import { FiltersProvider } from 'pages/search/filters/filters-context';
import { SearchProvider } from 'pages/search/search-context';
import { ResultsProvider } from 'pages/shared/results-context';
import { UserRole } from 'providers/user';
import React from 'react';
import { SubIndex } from 'shared/sub-index.enum';
import { withAuthentication } from 'utils/with-authentication';
import { Info } from '../search/info/info';
import { PrimeFilterProvider } from '../search/prime/prime-context';
import Create from './create';
import Edit from './edit';
import { MyCatalogues } from './my-catalogues/my-catalogues';
import { CreatePenCard } from './pen-cards/create-pen-card/create-pen-card';
import { SalesCatalogue } from './sales/sales-catalogue/sales-catalogue';
import { SalesCatalogues } from './sales/sales-catalogues/sales-catalogues';
import { SemenCatalogue } from './semen/semen-catalogue/semen-catalogue';
import { SemenCatalogues } from './semen/semen-catalogues/semen-catalogues';

export default compose(
  mount({
    '/sales': route((req) => {
      const {
        user, db, scenario,
      } = req.params;
      return {
        view: (
          <>
            <Info />
            <SalesCatalogues
              user={parseInt(user)}
              db={parseInt(db)}
              trait={parseInt(scenario) as SubIndex}
            />
          </>
        ),
      };
    }),
    '/create': withAuthentication(
      [UserRole.Admin, UserRole.Breeder, UserRole.ServiceProvider],
      route((req) => {
        const { type, db, userId } = req.params;

        return {
          view: <Create
            type={parseInt(type)}
            db={parseInt(db)}
            userId={userId}
          />,
        };
      }),
    ),
    '/edit/:id': withAuthentication(
      [UserRole.Admin, UserRole.Breeder, UserRole.ServiceProvider],
      route((req) => {
        const { catalogue } = req.state;
        const {
          type, id, db, step,
        } = req.params;

        return {
          view: <Edit
            catalogue={catalogue}
            id={id}
            type={parseInt(type)}
            db={parseInt(db)}
            step={parseInt(step) || 1}
          />,
        };
      }),
    ),
    '/sales/:id': route((req) => {
      const {
        id, user, db, scenario,
      } = req.params;
      return {
        view:
  <SearchProvider>
    <FiltersProvider>
      <ResultsProvider>
        <Info />
        <SalesCatalogue
          user={parseInt(user)}
          db={parseInt(db)}
          id={parseInt(id)}
          trait={scenario ? parseInt(scenario) : scenario}
        />
      </ResultsProvider>
    </FiltersProvider>
  </SearchProvider>,
      };
    }),
    '/semen': route((req) => {
      const {
        user, db, scenario,
      } = req.params;
      return {
        view: (
          <>
            <Info />
            <SemenCatalogues
              user={parseInt(user)}
              db={parseInt(db)}
              trait={parseInt(scenario) as SubIndex}
            />
          </>
        ),
      };
    }),
    '/semen/:id': route((req) => {
      const {
        id, user, db, scenario,
      } = req.params;
      return {
        view:
  <SearchProvider>
    <FiltersProvider>
      <ResultsProvider>
        <Info />
        <SemenCatalogue
          user={parseInt(user)}
          db={parseInt(db)}
          id={parseInt(id)}
          trait={scenario ? parseInt(scenario) : scenario}
        />
      </ResultsProvider>
    </FiltersProvider>
  </SearchProvider>,
      };
    }),
    '/my': withAuthentication(
      [UserRole.Admin, UserRole.Breeder, UserRole.ServiceProvider],
      route((req) => {
        const {
          user, db, scenario, asbvs, breederId, breederName,
        } = req.params;
        return {
          view: (
            <PrimeFilterProvider>
              <FiltersProvider>
                <MyCatalogues
                  user={parseInt(user)}
                  db={parseInt(db)}
                  breederId={breederId}
                  breederName={breederName}
                  trait={parseInt(scenario) as SubIndex}
                  asbvs={asbvs}
                />
              </FiltersProvider>
            </PrimeFilterProvider>
          ),
        };
      }),
    ),
    '/my/pen-card/:id': withAuthentication(
      [UserRole.Admin, UserRole.Breeder, UserRole.ServiceProvider],
      route((req) => {
        const {
          id, db, scenario, user,
        } = req.params;
        return {
          view: <CreatePenCard
            id={id}
            db={parseInt(db)}
            trait={parseInt(scenario) as SubIndex}
            user={parseInt(user)}
          />,
        };
      }),
    ),
  }),
);
